fabric.Object.prototype.noScaleCache = false;
var locket,locketURL,checkType,object,cURL,charm=1,cLeft,cTop,rotation,proID,charms,
    newZoomLevel,zoom,prevCharm,Objects,step,
    loader = jQuery('#customLoader'),
    orderArray = new Array(),remoID,endOrder,
    cSize = '765.188',// jQuery('.product__section-images').innerWidth(),
    topBase= cSize * 1.25,
    baseImg = jQuery('.base.active').attr('src'),
    canvas = this.__canvas = new fabric.Canvas('customArea',{
      width: cSize,
      height: topBase,
      backgroundColor: '#FFFFFF',
      preserveObjectStacking: true,
      isTouchSupported: false,
      selection: false
    });

/* document.getElementById("addToCartM").addEventListener("click", function() {

  setTimeout(function() {
        var div = document.querySelector(".ajax-cart__cart-items"); // Select the <div> element by its class
        var uls = div.querySelectorAll("ul.ajax-cart__cart-item");

        for (var i = 0; i < uls.length - 1; i++) {
            var span = uls[i].querySelector("span[data-cart-item-regular-price]");
            if (span && span.textContent.trim() === "$0.00") {
                div.removeChild(uls[i]);
            }
        }

        // Update the content of the span with class "js-cart-count" to "1"
        var cartCount = document.querySelector(".js-cart-count");
        if (cartCount) {
            cartCount.textContent = "1";
        } else {
            console.log("Span with class 'js-cart-count' not found.");
        }
    }, 1800);
}); */




document.getElementById("pendentreset").addEventListener("click", function() {
    location.reload();
});
















jQuery(document).on('change', 'input[name="options[Size]"]', function() {
  var checkNum = jQuery(this).val();
  charms = parseInt(checkNum.match(/-?\d+\.?\d*/));
  jQuery('.chanDo').text(charms);
  charms++;
});

jQuery(document).on('change','input[name="style"]',function(){
  var checkNum = jQuery(this).val();
  if(checkNum == 'BRACELET'){
    charms = '6';
  }
  else{
    charms = '8';
  }
  jQuery('.chanDo').text(charms);
  charms++;
});

jQuery(document).on('click','.stpNext',function(){



  
  step = 'fwd';
  if(jQuery('.steps__.active').attr('data-sol') == 'pendant'){
    jQuery('.steps__.active').removeClass('active').next('.steps__').addClass('active');
    jQuery('.cNum').show();
    jQuery('.pNum').hide();
  }
  stepChanged(step);

});

jQuery(document).on('click','.stpPrev',function(){

  step = 'bck';
  jQuery('input[name="agreement"]').prop('checked', false);
  stepChanged(step);
  if(prevCharm < 1){
    jQuery('.steps__.active').removeClass('active').prev('.steps__').addClass('active');
    jQuery('.cNum').hide();
    jQuery('.pNum').show();
    jQuery('.stpPrev').attr('disabled','disabled');
    jQuery('.overRate>h3').text('Select Your Pendant');
  }

});

function stepChanged(step){
/*  jQuery('html,body').animate({
    scrollTop: jQuery('.pendantsList').offset().top - 1
  }, 'slow');*/
  prevCharm = jQuery('.steBTns').attr('data-current');
  jQuery('.locket.active').each(function(){
    jQuery(this).removeClass('active');
  });
  canvas.discardActiveObject().renderAll();
  Objects = canvas.getObjects();
  if(step == 'fwd'){
    prevCharm = parseInt(prevCharm) + 1;
    jQuery('.stpPrev').removeAttr('disabled');
    if(prevCharm == charm){
      jQuery('.stpNext').attr('disabled','disabled');
    }
    else if((prevCharm+1) == charm && charm == charms){
      jQuery('.stpNext').attr('disabled','disabled');
    }
  }
  else{
    prevCharm = parseInt(prevCharm) - 1;
    jQuery('.stpNext').removeAttr('disabled');
  }
  Objects.forEach(function(object){
    type = object.id;
    if(type == 'ch'+prevCharm){
      canvas.setActiveObject(object).renderAll();
    }
  });
  jQuery('.product-index[data-product-id="'+orderArray[prevCharm]+'"] .locket').addClass('active');
  jQuery('.overRate>h3').text('Select Charm '+ prevCharm);
  jQuery('.steBTns').attr('data-current',prevCharm);
   
}

fabric.Object.prototype.borderColor = '#c60808';
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = '#7c8f7f';
fabric.Object.prototype.cornerStyle = 'circle';

canvasBlock();

fabric.Image.fromURL(baseImg, function(img){
  var oImg = img.set({
    left:0,
    top:0,
    selectable: false,
    evented: false,
    hoverCursor: 'default'
  }).scaleToWidth(cSize);
  canvas.setBackgroundImage(oImg);
  canvas.requestRenderAll();
});

jQuery(window).on('load',function(){
  jQuery('input[name="style"]:checked').trigger('click').change();
//  jQuery('input[name="size"]:checked').trigger('click').change();
  jQuery('input[name="options[Size]"]:checked').trigger('change');

//  jQuery('select[name="options[Size]"]').trigger('change');
});

jQuery(window).resize(function(){
  canvasBlock();
});

loader.hide();

jQuery(document).on('click','.locket',function(){
  locket = jQuery(this);
  loader.show();
  locketURL = locket.attr('data-img');
  checkType = locket.parent().parent().parent();
  proID = locket.parent().parent().attr('data-product-id');
  if(checkType.hasClass('pendants') || checkType.hasClass('Pendants')){
    if(!checkType.hasClass('added')){
      checkType.addClass('added');
      addPendant(locketURL);
    }else{
      updatePendant(locketURL);
    }
    jQuery(checkType).find('.locket.active').removeClass('active');
    jQuery('.stpNext').removeAttr('disabled');
  }
  else{
    object = canvas.getActiveObject();
    if(object != undefined){
      cURL = object._originalElement.currentSrc;
      cURL = cURL.replace(/^https?:/, '');
      jQuery('.locket.active').each(function(){
        var objU = jQuery(this).attr('data-img');
        if(objU == cURL){
          remoID = jQuery(this).parent().parent().attr('data-product-id');
          jQuery(this).removeClass('active');
        }
      });
      updCharm(locketURL);
    }
    else{
      if(charm < charms){
        addCharm(locketURL);
      }else{
        alert("You can't add more");
        loader.hide();
        return
      }
    }
  }
  locket.addClass('active');
});

function canvasBlock(){
  jQuery('.product__section-images').removeAttr('style');
  zoom = jQuery('.product__section-images').innerWidth();
  newZoomLevel = zoom / cSize;
  setZoomMask(newZoomLevel);
}

function setZoomMask(newZoomLevel){
  var zoomLevel = newZoomLevel;
  canvas.setZoom(zoomLevel);
  canvas.setDimensions({
    width: cSize * zoomLevel,
    height: topBase * zoomLevel
  });
  canvas.renderAll();
  var proListHeight = (topBase * zoomLevel) - (jQuery('.numbersSlips').height() + 60);
  jQuery('.steps__').each(function(){
    if (window.matchMedia("(max-width: 767px)").matches){
      jQuery(this).css('max-height','calc(100vh - 350px)');
    }else{
      jQuery(this).css('max-height',cSize-60);
    }
  });
}

function addPendant(locketURL){
  fabric.Image.fromURL(locketURL, function(img){
    var oImg = img.set({
      id: 'pendant',
      left:cSize/2,
      top:topBase/1.41,
      originX: 'center',
      originY: 'top',
      scaleX: .19,// (canvas.getHeight() / canvas.getWidth()) / 5.68,//
      scaleY: .19,// (canvas.getHeight() / canvas.getWidth()) / 5.68//
      selectable:false
    });
    oImg.lockMovementX = true;
    oImg.lockMovementY = true;
    canvas.add(oImg);
    canvas.requestRenderAll();
    orderArray[0] = proID;
    loader.hide();
  });
  jQuery('.pndntNum').text('1');
}

function updatePendant(locketURL){
  Objects = canvas.getObjects();
  Objects.forEach(function(object){
    type = object.id;
    if(type == 'pendant'){
      var obLft = object.left,
          obScl = object.scaleY;
      object.setSrc(locketURL);
      object.left = obLft - .05;
      object.scaleY = obScl - .001;
      object.setCoords();
      canvas.requestRenderAll();
      setTimeout(function(){
        object.left = obLft;
        object.scaleY = obScl;
        object.setCoords();
        canvas.requestRenderAll();
        loader.hide();
      },1000);
    }
    orderArray[0] = proID;
    jQuery('.stpNext').removeAttr('disabled');
  });
}

function setSpace(charm){
  if(charm == 1){
    cLeft = (cSize/2) - (cSize/7.2);
    cTop = topBase/1.435;
    rotation = 10;
  }
  else if(charm == 2){
    cLeft = (cSize/2) + (cSize/6.9);
    cTop = topBase/1.439;
    rotation = -13;
  }
  else if(charm == 3){
    cLeft = (cSize/2) - ((cSize/7.2) + (cSize/11));
    cTop = topBase/1.493;
    rotation = 11;
  }
  else if(charm == 4){
    cLeft = (cSize/2) + ((cSize/12) + (cSize/11) + (cSize/14.5));
    cTop = topBase/1.51;
    rotation = -20;
  }
  else if(charm == 5){
    cLeft = (cSize/2) - ((cSize/9) + (cSize/11) + (cSize/11));
    cTop = topBase/1.58;
    rotation = 28;
  }
  else if(charm == 6){
    cLeft = (cSize/2) + ((cSize/12) + (cSize/12) + (cSize/12) + (cSize/18));
    cTop = topBase/1.605;
    rotation = -35;
  }
  else if(charm == 7){
    cLeft = (cSize/2) - ((cSize/12) + (cSize/12) + (cSize/12) + (cSize/11));
    cTop = topBase/1.70;
    rotation = 35;
  }
  else if(charm == 8){
    cLeft = (cSize/2) + ((cSize/10) + (cSize/11) + (cSize/11) + (cSize/18));
    cTop = topBase/1.76;
    rotation = -48;
  }
  else if(charm == 9){
    cLeft = (cSize/2) - ((cSize/14) + (cSize/14) + (cSize/14) + (cSize/14) + (cSize/14));
    cTop = topBase/1.68;
    rotation = 31;
  }
  else if(charm == 10){
    cLeft = (cSize/2) + ((cSize/15) + (cSize/15) + (cSize/14) + (cSize/14) + (cSize/14));
    cTop = topBase/1.65;
    rotation = -29;
  }
}

function addCharm(locketURL){
  setSpace(charm);
  fabric.Image.fromURL(locketURL, function(img){
    var sImg = img.set({
      id: 'ch'+charm,
      left:cLeft,
      top:cTop,
      originX: 'center',
      originY: 'top',
      scaleX: .25,
      scaleY: .25,
      angle: rotation
    });
    sImg.lockMovementX = true;
    sImg.lockMovementY = true;
    canvas.add(sImg).setActiveObject(sImg);
    canvas.requestRenderAll();
    if(jQuery('#customizingArea').attr('data-charm') != ''){
      orderArray[charm] = proID;
      charm = jQuery('#customizingArea').attr('data-charm');
      jQuery('#customizingArea').attr('data-charm','');
      jQuery('.charmNum').text(charm-1);
    }else{
      orderArray.push(proID);
      jQuery('.charmNum').text(charm);
      charm++;
      if(charm < charms){
        jQuery('.stpNext').removeAttr('disabled').attr('data-set',charm);
      }
      else{
        showAgreement();
document.querySelector('.stpNext').value = 'Selection Done';

        
      }
    }
    loader.hide();
  });
}

function showAgreement(){
  jQuery('#showAgreement').addClass('active');
  jQuery(document).on('change','input[name="agreement"]',function(){
    jQuery('#allowCharm').val(jQuery(this).val());
    if(jQuery(this).is(':checked')){
      //jQuery('#showAgreement').removeClass('active');
      jQuery('.js-ajax-submitM').removeAttr('disabled');
    }else{
      jQuery('#showAgreement').addClass('active');
      jQuery('.js-ajax-submitM').attr('disabled','disabled');
    }
  });
}

function updCharm(locketURL){
  var obLft = object.left,
      obScl = object.scaleY;
  object.setSrc(locketURL);
  object.left = obLft - .025;
  object.scaleY = obScl - .005;
  object.setCoords();
  canvas.requestRenderAll();
  setTimeout(function(){
    object.left = obLft;
    object.scaleY = obScl;
    object.setCoords();
    canvas.requestRenderAll();
    loader.hide();
  },1000);
  var replaceAr = object.id;
  replaceAr = replaceAr.slice(2);
  orderArray[replaceAr] = proID;
  jQuery('.stpNext').removeAttr('disabled');
}

function deleteObject(eventData,transform){
  var target = transform.target;
  var canvas = target.canvas;
  var idT = target.id;
  cURL = target._originalElement.currentSrc;
  cURL = cURL.replace(/^https?:/, '');
  jQuery('.locket.active').each(function(){
    var objU = jQuery(this).attr('data-img');
    if(objU == cURL){
      jQuery(this).removeClass('active');
    }
  });
  if(idT == 'pendant'){
    jQuery('.pendants.added,.Pendants.added').removeClass('added');
    jQuery('.pndntNum').text('0');
    jQuery('.stpNext').attr('disabled','disabled');
  }
  else{
    jQuery('#customizingArea').attr('data-charm',charm);
    jQuery('.charmNum').text(charm-2);
    charm = idT.replace('ch','');
  }
  canvas.remove(target);
  canvas.requestRenderAll();
}

function renderIcon(icon){
  return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    var size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size/2, -size/2, size, size);
    ctx.restore();
  }
}

var otherProducts = '',storke;
jQuery(document).on('click','.js-ajax-submitM',function(e){
  e.preventDefault();
  loader.show();
  for(var i=0; i < orderArray.length; i++){
    if([i] == 0){
      storke = 'Pendant';
    }else{
      storke = 'Charm '+ [i];
    }
    jQuery('.myOrders').append('<input type="hidden" name="items['+i+'][id]" value="'+parseInt(orderArray[i])+'">');
    jQuery('.steps__ .product-index').each(function(){
      var thisC = jQuery(this);
      if(orderArray[i] == thisC.attr('data-product-id')){
        otherProducts = thisC.attr('data-alpha');
        jQuery('.myProperty').append('<input name="properties['+storke+']" type="hidden" value="'+otherProducts+'">');
      }
    });
  }
  /*endOrder = canvas.toDataURL({
    format: 'jpg',
    quality: 1
  });
  jQuery('.endItems').val(otherProducts);*/
  Objects = canvas.getObjects();
  Objects.forEach(function(object){
    canvas.remove(object).requestRenderAll();
  });
  orderArray = [];
  jQuery('.locket.active').each(function(){
    jQuery(this).removeClass('active');
  });
  charm = 1;
  jQuery('.steBTns').attr('data-current',0);
  jQuery('.stepBtn').attr('data-set',1);
  jQuery('.added').removeClass('added');
  jQuery('.pndntNum').text('0');
  jQuery('.pndntNum,.charmNum').text('0');
  jQuery('.cNum').hide();
  jQuery('.pNum').show();
  jQuery('.steps__.active').removeClass('active');
  jQuery('.steps__[data-sol="pendant"]').addClass('active');
  jQuery('.overRate>h3').text('Select Your Pendant');
  jQuery('.stpPrev').attr('disabled','disabled');
  jQuery('.stpNext').attr('disabled','disabled');
  jQuery('.js-ajax-submitM').attr('disabled','disabled');
   jQuery('.js-ajax-submit').trigger('click');
   setTimeout(function(){
     loader.hide();
     jQuery('.myOrders').html('');
     jQuery('.myProperty').html('');
   },500);
});

canvas.on('object:added', function(e){
  object = e.target;
  object.setControlsVisibility({
    bl: false,
    br: false,
    mb: false,
    ml: false,
    mr: false,
    mt: false,
    mtr: false,
    tl: false,
    tr: false
  });
});
canvas.on('object:modified', function(e){
  object = e.target;
});

const svgRotateIcon = encodeURIComponent(`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d)">
    <circle cx="9" cy="9" r="5" fill="white"/>
    <circle cx="9" cy="9" r="4.75" stroke="black" stroke-opacity="0.3" stroke-width="0.5"/>
  </g>
    <path d="M10.8047 11.1242L9.49934 11.1242L9.49934 9.81885" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.94856 6.72607L8.25391 6.72607L8.25391 8.03142" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.69517 6.92267C10.007 7.03301 10.2858 7.22054 10.5055 7.46776C10.7252 7.71497 10.8787 8.01382 10.9517 8.33642C11.0247 8.65902 11.0148 8.99485
    10.9229 9.31258C10.831 9.63031 10.6601 9.91958 10.4262 10.1534L9.49701 11.0421M8.25792 6.72607L7.30937 7.73554C7.07543 7.96936 6.90454 8.25863 6.81264
    8.57636C6.72073 8.89408 6.71081 9.22992 6.78381 9.55251C6.8568 9.87511 7.01032 10.174 7.23005 10.4212C7.44978 10.6684 7.72855 10.8559 8.04036 10.9663"
    stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  <defs>
  <filter id="filter0_d" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.137674 0 0 0 0 0.190937 0 0 0 0 0.270833 0 0 0 0.15 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
  </filter>
  </defs>
</svg>
`)
const rotateIcon = `data:image/svg+xml;utf8,${svgRotateIcon}`
const brIcon = document.createElement('img')

const svgRemoveIcon = encodeURIComponent(`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d)">
    <circle cx="9" cy="9" r="5" fill="white"/>
    <circle cx="9" cy="9" r="4.75" stroke="black" stroke-opacity="0.3" stroke-width="0.5"/>
  </g>
  <path fill="#000" d="M6.9,11.1c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1L9,9.4l1.6,1.6c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
		c0.1-0.1,0.1-0.3,0-0.4L9.4,9l1.6-1.6c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0L9,8.6L7.4,6.9c-0.1-0.1-0.3-0.1-0.4,0
		c-0.1,0.1-0.1,0.3,0,0.4L8.6,9l-1.6,1.6C6.8,10.8,6.8,10.9,6.9,11.1z"/>
  <defs>
  <filter id="filter0_d" x="0" y="0" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.137674 0 0 0 0 0.190937 0 0 0 0 0.270833 0 0 0 0.15 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
  </filter>
  </defs>
</svg>
`)
const removeIcon = `data:image/svg+xml;utf8,${svgRemoveIcon}`
const tlIcon = document.createElement('img');
brIcon.src = rotateIcon;
tlIcon.src = removeIcon;

// Changing control properties
fabric.Object.prototype.controls.br = new fabric.Control({
  x: .5,
  y: .5,
  offsetX: 0,
  offsetY: 0,
  cursorStyle: 'crosshair',
  actionHandler: fabric.controlsUtils.rotationWithSnapping,
  actionName: 'rotate',
  render: renderIcon(brIcon),
  cornerSize: 38,
  withConnection: true
});
fabric.Object.prototype.controls.tl = new fabric.Control({
  x: -.5,
  y: -.5,
  offsetX: 0,
  offsetY: 0,
  cursorStyle: 'pointer',
  mouseUpHandler: deleteObject,
  render: renderIcon(tlIcon),
  cornerSize: 38,
  withConnection: true
});